import React, { useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
//import axios from "axios";
import FileUpladLoader from "./fileUploadLoader";
import api from '../services/api';
import { getTexts } from "../utils/i18n";

// FilePond eklentilerini kaydetme
registerPlugin(FilePondPluginFileValidateType, FilePondPluginImagePreview);

interface FileUploadPopupProps {
    isVisible: boolean;
    onClose: () => void;
    onUploadSuccess: (file: File) => void;
}

const FileUploadPopup: React.FC<FileUploadPopupProps> = ({ isVisible, onClose, onUploadSuccess }) => {
    const [files, setFiles] = useState<File[]>([]);
    const [isUploading, setIsUploading] = useState(false); // Yükleme durumunu takip için
    const texts = getTexts();

    const handleUpload = async () => {
        if (files.length > 0) {
            const formData = new FormData();
            files.forEach((file) => {
                formData.append("files", file);
            });
            var guid = sessionStorage.getItem('chatGuid'); // Varsa kullan, yoksa oluştur
            if (guid) {
                formData.append("GUID", guid);
            }

            setIsUploading(true);
            try {
                // botType'ı 1 olarak ayarla
                sessionStorage.setItem('botType', "1");

                const response = await api.post("/api/Chat/UploadAnalysis", formData);
                console.log("API Yanıtı:", response.data);

                sessionStorage.setItem('chatGuid', response.data.guid);
                files.forEach(element => {
                    onUploadSuccess(element);
                });

                // Başarılı yükleme sonrası inputsDisabled'ı false yap
                if (typeof window !== 'undefined') {
                    (window as any).setInputsDisabled?.(false);
                }

                onClose();
            } catch (error) {
                console.error("Yükleme sırasında hata oluştu:", error);
                alert(texts.uploadError);
            } finally {
                setIsUploading(false);
                setFiles([]);
            }
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fullscreen-popup" id="aiChatPopup">
            <div className="popup-content">
                <h3>{texts.uploadTitle}</h3>
                {/* <img className="gif" src="/images/ChatAi1.gif" alt="Hoşgeldiniz" /> */}
                <p>{texts.uploadDescription}</p>

                {/* FilePond Bileşeni */}
                <FilePond
                    files={files}
                    onupdatefiles={(fileItems) => setFiles(fileItems.map((fileItem) => fileItem.file as File))}
                    allowMultiple={false} // Birden fazla dosya istemiyorsanız
                    maxFiles={3} // Maksimum dosya sayısı
                    acceptedFileTypes={["application/pdf", "image/*"]} // Kabul edilen dosya türleri
                    name="file"
                    labelIdle={texts.uploadDropLabel}
                />

                <div className="button-container">
                    <button id="uploadfileclosebtn" className="close-btn" onClick={onClose} disabled={isUploading}>
                        {texts.close}
                    </button>
                    <button className="btn btn-approve" onClick={handleUpload} disabled={files.length === 0 || isUploading}>
                        {isUploading ? texts.uploading : texts.send}
                    </button>
                </div>

                {isUploading && <FileUpladLoader />}



            </div>
        </div>
    );
};

export default FileUploadPopup;
